export const AppSettings = {
  REQUEST_TIMEOUT: 25000, // 25s
  REQUESTTIMEOUT_UPLOAD: 300000, // 5min = 5*60*1000
};
